import { corners, marginBottom, marginLeft, marginTop, paddingX, paddingY, typography } from "../../styles";
import { applyOpacity } from "../../styles/utils";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Notification from "../Notification/Notification";
import styled from "styled-components";
export const Label = styled.label`
  display: inline-block;
  ${typography.body};
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.6)};
  &::first-letter {
    text-transform: capitalize;
  }
`;
export const HelpText = styled.div`
  ${typography.small}
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.8)}
`;
export const RequiredStar = styled(FontAwesomeIcon).attrs({
  icon: faAsterisk
})`
  max-height: 0.5rem;
  max-width: 0.5rem;
  color: ${({
  theme
}) => theme.colours.error};
  ${marginLeft.xs}
  ${marginBottom.s}
`;
export const Input = styled.input<{
  error: boolean;
}>`
  width: 100%;
  background-color: ${({
  theme
}) => theme.colours.white};
  ${paddingX.s}
  ${paddingY.xs}

  ${corners.s}
  border: 1px solid ${({
  error,
  theme
}) => error ? theme.colours.error : applyOpacity(theme.colours.dark, 0.6)};

  ${typography.body}

  &::placeholder {
    color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.4)};
  }
`;
export const Error = styled(Notification).attrs({
  variant: "warning"
})``;

// Plugs the gaps in the background colour caused by rounded corners on Input and Error.
// Input and Error should be put in this container
export const ErrorConnector = styled.div<{
  show?: boolean;
}>`
  background-color: ${({
  show,
  theme
}) => show ? applyOpacity(theme.colours.error, 0.1) : "none"};
  ${corners.m}
  ${marginTop.s}
  ${marginBottom.m}
`;